import { render } from "./PredictionSuccess.vue?vue&type=template&id=f57b2c8a&scoped=true"
import script from "./PredictionSuccess.vue?vue&type=script&lang=js"
export * from "./PredictionSuccess.vue?vue&type=script&lang=js"

import "./PredictionSuccess.vue?vue&type=style&index=0&id=f57b2c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57b2c8a"]])

export default __exports__